export default [
    {
      path: '/wxAppSwitch',
      name: 'wxAppSwitch',
      meta: {
        title: '小程序环境设置'
      },
      component(resolve) {
        require(['COMPONENTS/wxAppSwitch/main'], resolve)
      },
    }
]
